import { create } from "zustand";

type ModalState = {
    modals: Record<string, { isOpen: boolean; data?: unknown }>;
};

type ModalActions = {
    open: (id: string, data?: unknown) => void;
    close: (id: string) => void;
    isOpen: (id: string) => boolean;
    getData: <T = unknown>(id: string) => T | undefined;
};

const useStoreModal = create<ModalState & ModalActions>((set, get) => ({
    modals: {},

    open: (id, data) => set((state) => ({
        modals: { ...state.modals, [id]: { isOpen: true, data } },
    })),

    close: (id) => set((state) => ({
        modals: { ...state.modals, [id]: { isOpen: false } },
    })),

    isOpen: (id) => get().modals[id]?.isOpen ?? false,

    getData: <T = unknown>(id: string) => get().modals[id]?.data as T | undefined,
}));

export default useStoreModal;
